import { styled } from "@linaria/react";

import SpinAnimation from "@gx/dls/animations/SpinAnimation";
import Spacing from "@gx/dls/containers/Spacing";
import GalaxyLogomark from "@gx/dls/icons/GalaxyLogomark";
import Text, { TextVariant } from "@gx/dls/text/Text";
import { withTheme, type PropsWithTheme } from "@gx/dls/theme";

const FullScreenLoaderWrapper = withTheme(styled.div<PropsWithTheme>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  background-color: ${({ theme }) => theme.color.background.base};
`);

interface FullScreenLoaderProps {
  icon?: React.ReactNode;
  header?: string;
}

const FullScreenLoader = ({ icon, header }: FullScreenLoaderProps) => {
  return (
    <FullScreenLoaderWrapper>
      <SpinAnimation speed={1.5}>{icon || <GalaxyLogomark height={20} />}</SpinAnimation>
      {header && (
        <Spacing top={20}>
          <Text variant={TextVariant.TERTIARY}>{header}</Text>
        </Spacing>
      )}
    </FullScreenLoaderWrapper>
  );
};

export default FullScreenLoader;
